module.exports = __webpack_public_path__ + "static/media/2.24e25c28.jpg";